import React from "react";
import Mentor1 from "@img/mentor1.png";
import Mentor2 from "@img/mentor2.png";
import Mentor3 from "@img/mentor3.png";
import Mentor4 from "@img/mentor4.png";
import Mentor5 from "@img/mentor5.png";
import FloatingMenu from "../components/FloatingMenu";
import { useEffect, useState } from "react";

function Mentor() {
  const [mentor, setMentor] = useState([]);

  useEffect(() => {
    fetchMentor();
  }, []);

  const fetchMentor = async () => {
    try {
      const response = await fetch("https://cms.okoce.net/api/admin/mentors");
      if (!response.ok) {
        throw new Error("Gagal mengambil data mentor");
      }
      const data = await response.json();
      setMentor(data.data[0] || []);
    } catch (error) {
      setMentor([]);
    }
  };

  const mentorImages = [Mentor1, Mentor2, Mentor3, Mentor4, Mentor5];

  return (
    <>
      <div className="flex overflow-hidden relative flex-col items-start px-12 py-20 text-white shadow-sm min-h-[825px] max-md:px-5">
        <img
          loading="lazy"
          src={`${process.env.REACT_APP_API_URL}/${mentor.image}`}
          className="object-cover absolute inset-0 size-full"
          alt={`Header ${mentor.image}`}
        />
        <div className="relative text-4xl font-bold leading-10 max-md:mt-10 max-md:max-w-full mobile:mt-64 lg:mt-96">
          {mentor.title}
        </div>
        <div
          className="relative text-lg leading-7 text-justify w-[616px] max-md:max-w-full mobile:mt-0 lg:mt-6"
          dangerouslySetInnerHTML={{ __html: mentor.description }}
        />
      </div>
      {/* Kenapa jadi mentor */}
      {mentor?.cta && (
        <div className="flex flex-col px-16 py-20 ml-10 mr-10 text-black max-md:px-5">
          <div className="mt-6 text-4xl font-bold leading-10 max-md:text-3xl">
            {mentor.cta[0]?.cta_title}
          </div>
          <div
            className="mt-7 text-lg leading-7 text-justify max-md:text-base"
            dangerouslySetInnerHTML={{ __html: mentor.cta[0]?.cta_description }}
          />
        </div>
      )}
      {/* Kenapa jadi mentor */}
      {/* syarat Menjadi mentor */}
      <div className="flex flex-col px-16 py-20 bg-[#1c75ac] max-md:px-5">
        <div className="mt-8 max-md:max-w-full">
          <h1 className="mt-5 text-4xl font-bold leading-10 text-white">
              Syarat menjadi Mentor
          </h1>
        </div>
        <div className="mt-24 max-md:mt-10 max-md:max-w-full">
          <div className="flex gap-5 max-md:flex-col max-md:gap-0">
            {mentor?.terms?.map(
              ({ terms_title, terms_description }) => (
                <div className="flex flex-col flex-1 max-md:ml-0">
                  <div className="flex flex-col text-white rounded-xl bg-[#1c75ac] border-white border-2 p-4 max-md:mt-10 min-h-[250px]">
                    <div className="text-2xl font-bold leading-8 mb-4">
                      {terms_title}
                    </div>
                    <div
                      className="text-lg leading-7 text-justify flex-grow"
                      dangerouslySetInnerHTML={{ __html: terms_description }}
                    />
                  </div>
                </div>
              )
            )}
          </div>
        </div>
        {/* <div className="justify-center items-center self-center px-16 py-4 mt-36 max-w-full text-xl font-semibold leading-6 text-center text-white bg-red-600 rounded-[50px] w-[441px] max-md:px-5 max-md:mt-10">
          MULAI BEKERJASAMA
        </div> */}
      </div>
      {/* syarat Menjadi mentor End */}
      {/* Benefit menjadi mentor */}
      <div className="flex flex-col ml-3 mr-3 mb-10 px-11 pt-2.5 pb-4 max-md:px-5">
        <div className="text-5xl font-bold text-black leading-[57.6px] max-md:max-w-full max-md:text-4xl">
          Benefit Menjadi Mentor
        </div>
        <div className="mt-8 text-lg leading-4 text-neutral-700 max-md:max-w-full">
          Menjadi trainer memberikan kesempatan untuk berbagi pengetahuan,
          memperluas jaringan profesional, dan merasa puas melihat perkembangan
          peserta.
        </div>
        <div className="mt-12 max-md:mt-10 max-md:max-w-full">
              <div className="flex flex-wrap gap-5 max-md:flex-col max-md:gap-0">
                {mentor?.benefit?.map(
                  ({ benefit_title, benefit_description }, index) => (
                    <div
                      key={index}
                      className="flex flex-col w-[32%] max-md:w-full"
                      style={{ marginBottom: "20px" }}
                    >
                      <div className="flex flex-col grow px-8 pt-5 pb-16 w-full text-black bg-white rounded-3xl border border-indigo-800 border-solid shadow-md max-md:px-5 max-md:mt-6">
                        <img
                          src={mentorImages[index % mentorImages.length]}
                          className="aspect-square w-[50px]"
                          alt={`Benefit ${(index % mentorImages.length) + 1}`}
                        />
                        <div className="mt-4 text-2xl font-bold leading-9">
                          {benefit_title}
                        </div>
                        <div
                          className="mt-4 text-base leading-6 text-justify"
                          dangerouslySetInnerHTML={{
                            __html: benefit_description,
                          }}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
      </div>
      {/* Benefit menjadi mentor end */}
      <FloatingMenu />{" "}
    </>
  );
}

export default Mentor;
